import { render, staticRenderFns } from "./BillDetail - 副本.vue?vue&type=template&id=256b42cf&scoped=true"
import script from "./BillDetail - 副本.vue?vue&type=script&lang=js"
export * from "./BillDetail - 副本.vue?vue&type=script&lang=js"
import style0 from "./BillDetail - 副本.vue?vue&type=style&index=0&id=256b42cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b42cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256b42cf')) {
      api.createRecord('256b42cf', component.options)
    } else {
      api.reload('256b42cf', component.options)
    }
    module.hot.accept("./BillDetail - 副本.vue?vue&type=template&id=256b42cf&scoped=true", function () {
      api.rerender('256b42cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/dialog/BillDetail - 副本.vue"
export default component.exports